import { useEffect } from 'react';

import useUI from 'hooks/use-ui';

import { tracker } from '..';
import { ProductRecommendationSource } from '../trackers/internal-gtm-tracker/internal-gtm-tracker.types';

export const useProductPositionMonitor = (): void => {
  const UI = useUI();

  useEffect(() => {
    tracker.setContext({
      activeProductPosition: {
        index: UI?.productPosition?.productIndex,
        section: UI?.productPosition?.sectionIndex,
        source: ProductRecommendationSource.native,
      },
    });
  }, [UI?.productPosition?.productIndex, UI?.productPosition?.sectionIndex]);
};
